// extracted by mini-css-extract-plugin
export default {"CanvasWrap":"Canvas_CanvasWrap__H2L2I","Canvas":"Canvas_Canvas__wiSa+"};